import styled from 'styled-components';
import { renderDescriptionInput, renderExpectationItem, renderPasswordInput, renderShuffleQuestionOption, renderTitleInput, renderEnableSecurityOptionSwitchOption, renderSecurityOptionSelection, renderAutoBanOptions, renderShuffleAnswerOption, StyledRequiredMark, renderShowExplanationRadioOptions, renderDurationInput, renderShowExplanationSwitchOption } from './base-options.component';
import { Form, Select } from 'antd';
import { useEffect, useState } from 'react';
import { TextToHTMLTransformerComponent, TextLinkButton, WindowEdit, styleVariables, getSize, getColor, CardTitle, DefaultRangePicker } from '@lib/common';
import { CheckSquareOutlined } from '@ant-design/icons';
import { RichTextEditor } from '@lib/common';
import { disabledDate, disabledTime } from '../../utils/getPastTime';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var StyledSecurityOptionsContainer = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledSecurityOptionsContainer",
  componentId: "sc-1439gqc-0"
})(["margin:0 16px;"]);
var StyledTermsAndConditionHeader = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionHeader",
  componentId: "sc-1439gqc-1"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;"]);
var StyledTermsAndConditionsButton = styled(TextLinkButton).withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionsButton",
  componentId: "sc-1439gqc-2"
})(["display:flex;gap:5px;align-items:center;color:", ";span{margin:0;font-weight:500;}"], styleVariables.colors.primary60);
var StyledTermsAndConditionLabel = styled.span.withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionLabel",
  componentId: "sc-1439gqc-3"
})(["font-size:", ";font-weight:500;"], styleVariables.font.fontSizeSmall);
var StyledTermsAndConditionsContentContainer = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionsContentContainer",
  componentId: "sc-1439gqc-4"
})(["padding:16px;border-radius:", ";border:1px solid ", ";height:180px;overflow-y:auto;"], styleVariables.borderRadius.medium, styleVariables.colors.grey70);
var StyledTermsAndConditionsContent = styled(TextToHTMLTransformerComponent).withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionsContent",
  componentId: "sc-1439gqc-5"
})(["font-weight:400;font-size:", ";letter-spacing:0;line-height:", ";color:", ";cursor:pointer;p{margin:0;}img{max-width:100%;}"], getSize('typo14'), getSize('padding20'), getColor('contentTitle'));
var StyledRichTextEditor = styled(RichTextEditor).withConfig({
  displayName: "create-examination-optionscomponent__StyledRichTextEditor",
  componentId: "sc-1439gqc-6"
})(["height:180px;"]);
var StyledWrapper = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledWrapper",
  componentId: "sc-1439gqc-7"
})(["background-color:", ";padding:", ";border:1px solid #e6e8f0;border-radius:8px;margin-bottom:", ";"], getColor('fillBgSub'), getSize('gap24'), getSize('gap24'));
export var CreateExaminationOptions = function CreateExaminationOptions(props) {
  var label = props.label,
      errorLabel = props.errorLabel,
      securityOptions = props.securityOptions,
      isLoadingGetSecurityOptions = props.isLoadingGetSecurityOptions,
      form = props.form,
      editorLabels = props.editorLabels;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.basicInformation
      }), renderTitleInput(label, errorLabel), renderDescriptionInput(label)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.timeAndAttempts
      }), renderDurationInput(label, errorLabel), /*#__PURE__*/_jsx(Form.Item, {
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: label.deadline
          }), /*#__PURE__*/_jsx(StyledRequiredMark, {
            children: "*"
          })]
        }),
        name: "rangeDate",
        initialValue: [moment().add(10, 'minutes'), // Default start time: now + 10 minutes
        moment().add(40, 'minutes') // Default end time: start + 30 minutes
        ],
        dependencies: ['duration'],
        rules: [{
          required: true,
          message: errorLabel.selectDeadlineMessage
        }],
        children: /*#__PURE__*/_jsx(DefaultRangePicker, {
          disabledDate: disabledDate,
          disabledTime: disabledTime,
          showTime: {
            format: 'HH:mm'
          },
          format: "DD/MM/YYYY - HH:mm",
          placeholder: [label.startTime, label.endTime],
          onChange: function onChange(dates) {
            if (dates && dates.length === 2) {
              var duration = form.getFieldValue('duration');

              if (duration) {
                var startTime = dates[0];
                var currentEndTime = dates[1];
                var expectedEndTime = moment(startTime).add(duration, 'minutes');
                var timeDiff = Math.abs(currentEndTime.diff(expectedEndTime, 'minutes')); // if (timeDiff > 5 && timeDiff < 60) {
                //   form.setFieldsValue({ rangeDate: [startTime, expectedEndTime] });
                // }
              }

              form.validateFields(['duration']);
            }
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.shuffleSettings
      }), renderShuffleQuestionOption(label), renderShuffleAnswerOption(label)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.shareAndAccess
      }), renderPasswordInput(label, errorLabel)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.scoringAndResults
      }), renderShowExplanationRadioOptions(label, errorLabel), renderShowExplanationSwitchOption(label), renderExpectationItem(label, errorLabel)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.securityOptions
      }), renderEnableSecurityOptionSwitchOption(label), /*#__PURE__*/_jsxs(StyledSecurityOptionsContainer, {
        children: [renderAutoBanOptions(label, errorLabel), renderSecurityOptionSelection(isLoadingGetSecurityOptions, errorLabel, label, securityOptions), /*#__PURE__*/_jsx(TermsAndConditions, {
          label: label,
          editorLabels: editorLabels,
          form: form
        })]
      })]
    })]
  });
};

var TermsAndConditions = function TermsAndConditions(_ref) {
  var label = _ref.label,
      editorLabels = _ref.editorLabels,
      form = _ref.form;

  var _useState = useState(false),
      isEditing = _useState[0],
      setIsEditing = _useState[1];

  var _useState2 = useState(form.getFieldValue('termsAndConditions') || label.defaultTermsAndConditions),
      content = _useState2[0],
      setContent = _useState2[1];

  var handleEditorChangeText = function handleEditorChangeText(value) {
    setContent(value);
  };

  var toggleEditing = function toggleEditing() {
    setIsEditing(function (prev) {
      return !prev;
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      termsAndConditions: content
    });
  }, [content]);

  var reset = function reset() {
    setIsEditing(false);
  };

  var renderLabel = function renderLabel() {
    return /*#__PURE__*/_jsxs(StyledTermsAndConditionHeader, {
      children: [/*#__PURE__*/_jsx(StyledTermsAndConditionLabel, {
        children: label.termsAndConditions
      }), /*#__PURE__*/_jsxs(StyledTermsAndConditionsButton, {
        onClick: toggleEditing,
        children: [isEditing ? /*#__PURE__*/_jsx(CheckSquareOutlined, {
          color: styleVariables.colors.primary60
        }) : /*#__PURE__*/_jsx(WindowEdit, {}), /*#__PURE__*/_jsx("span", {
          children: isEditing ? label.complete : label.edit
        })]
      })]
    });
  };

  return /*#__PURE__*/_jsx(Form.Item, {
    shouldUpdate: function shouldUpdate(prevValues, currentValues) {
      return prevValues.hasSecurityOptions !== currentValues.hasSecurityOptions;
    },
    noStyle: true,
    children: function children(_ref2) {
      var getFieldValue = _ref2.getFieldValue;
      var hasSecurityOptions = getFieldValue('hasSecurityOptions');
      setContent(form.getFieldValue('termsAndConditions') || label.defaultTermsAndConditions);

      if (!hasSecurityOptions) {
        reset();
      }

      return hasSecurityOptions && /*#__PURE__*/_jsxs(_Fragment, {
        children: [renderLabel(), /*#__PURE__*/_jsx(Form.Item, {
          name: "termsAndConditions",
          children: isEditing ? /*#__PURE__*/_jsx(StyledRichTextEditor, {
            onChange: handleEditorChangeText,
            content: content,
            editorLabels: editorLabels,
            placeholder: "Enter terms and conditions",
            scrollable: true
          }) : /*#__PURE__*/_jsx(StyledTermsAndConditionsContentContainer, {
            children: /*#__PURE__*/_jsx(StyledTermsAndConditionsContent, {
              value: content
            })
          })
        })]
      });
    }
  });
};